import AdvisorDuplicateMap from "../../../components/DataCollection/Advisor/AdvisorDuplicateMap/AdvisorDuplicateMap";

export const AdvisorDuplicateMapScreen = () => {
  return (
    <div>
      <AdvisorDuplicateMap />
    </div>
  );
};
